import React, { useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { FileText, ArrowRight } from 'lucide-react';

const CustomPageDetail = ({ page, onBack }) => {
  const { lang } = useLanguage();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  if (!page) {
    return (
      <div className="min-h-screen pt-32 pb-20 flex flex-col items-center justify-center text-center px-4 font-urdu">
        <FileText className="w-16 h-16 text-gray-300 mb-4" />
        <h2 className="text-2xl font-bold text-gray-800 mb-2">پیج دستیاب نہیں</h2>
        <p className="text-gray-500 mb-6">یہ صفحہ موجود نہیں ہے یا اسے حذف کر دیا گیا ہے۔</p>
        <button
          onClick={onBack}
          className="px-6 py-2.5 bg-pansar-700 hover:bg-pansar-800 text-white rounded-xl text-sm font-bold flex items-center gap-2 transition"
        >
          <ArrowRight className="w-4 h-4" />
          واپس جائیں
        </button>
      </div>
    );
  }

  const title = lang === 'ur' ? (page.titleUrdu || page.title) : (page.titleEn || page.titleUrdu || page.title);

  return (
    <div className="min-h-screen pt-28 sm:pt-36 pb-20 px-4 sm:px-6 lg:px-8 bg-gray-50/50 selection:bg-pansar-200 selection:text-pansar-900">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-[2rem] p-6 sm:p-10 shadow-xs border border-gray-100/50">
          <h1 className={`text-2xl sm:text-4xl font-bold text-gray-900 mb-8 pb-6 border-b border-gray-100 ${lang === 'ur' ? 'font-urdu' : 'font-sans'}`}>
            {title}
          </h1>
          <div 
            className="prose prose-pansar max-w-none text-gray-700 leading-loose prose-headings:text-gray-900 prose-headings:font-bold prose-a:text-pansar-600 prose-img:rounded-2xl"
            style={{ 
              fontFamily: lang === 'ur' ? '"Jameel Noori Nastaleeq", "Noto Nastaliq Urdu", serif' : 'inherit',
              direction: lang === 'ur' ? 'rtl' : 'ltr',
              textAlign: lang === 'ur' ? 'right' : 'left'
            }}
            dangerouslySetInnerHTML={{ __html: page.contentHtml || page.content }}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomPageDetail;
